import { ReviewsSummary } from "@omni/types/api/reviews/bff/response/reviewsSummary.model";
import { cn } from "@omni/utils/styles";
import { isEmpty } from "lodash-es";

import { CreateReview } from "../createReview/createReview.container";
import { Recommendation } from "./components/recommendation/recommendation.component";
import { SecondaryRating } from "./components/secondaryRating/secondaryRating.component";
import { StarFilter } from "./components/starFilter/starFilter.component";
import { Summary } from "./components/summary/summary.component";

type ReviewsSummaryComponentProps = {
    reviewsSummary: ReviewsSummary;
};

export const ReviewsSummaryComponent = ({
    reviewsSummary
}: ReviewsSummaryComponentProps) => {
    return (
        <div className={cn("tw:max-w-80")}>
            <div className={cn("tw:mb-4")}>
                <Summary
                    range={reviewsSummary.range}
                    average={reviewsSummary.summary.average}
                    totalReviews={reviewsSummary.summary.count}
                />
            </div>
            {!isEmpty(reviewsSummary.distribution) && (
                <div className={cn("tw:mb-2")}>
                    <StarFilter
                        totalReviews={reviewsSummary.summary.count}
                        distribution={reviewsSummary.distribution}
                    />
                </div>
            )}
            <div className={cn("tw:mb-4")}>
                <Recommendation
                    recommendation={reviewsSummary.recommendation}
                />
            </div>
            {!!reviewsSummary.secondaryRating && (
                <div className={cn("tw:mb-4")}>
                    <SecondaryRating
                        secondaryRating={reviewsSummary.secondaryRating}
                    />
                </div>
            )}
            <div>
                <CreateReview />
            </div>
        </div>
    );
};
